import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
  selector: 'app-list-guidance-detail',
  templateUrl: './list-guidance-detail.component.html',
  styleUrls: ['./list-guidance-detail.component.scss'],
  standalone: false
})
export class ListGuidanceDetailComponent implements OnInit {


  currentPage = ''
  BaseUrl = ''
  constructor(
    private guidanceService: GuidanceService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private toast: ToastrService,
    private trusturl: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    @Inject('BASE_IMAGE_URL') _imageurl: any
  ) {
    this.BaseUrl = _imageurl
    this.currentPage = this.activatedRoute.snapshot.url[0].path;
  }
  title = 'angular-datatables';

  dataList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];
  originalList = new Array()
  getDetailData: any = [];


  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getDetailsList();
  }



  /* ***********
  list Detail
  *********** */

  getDetailsList() {
    this.spinner.show()
    this.guidanceService.getGuidanceDetail({ "isDelete": false }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.dataList = res.data;
        this.temp = this.dataList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }




  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter((d: any) => {
      const autoId = d.autoId?.toString() || '';
      const categoryName = d.guidanceCategoryId?.name?.toLowerCase() || '';
      const cardName = d.guidanceCardId?.name?.toLowerCase() || '';

      return (
        autoId.includes(val) ||
        categoryName.includes(val) ||
        cardName.includes(val)
      );
    });
    this.dataList = temp;
    this.myFilterTable.offset = 0;
  }


  getSanitizeUrl(url: string) {
    return this.trusturl.bypassSecurityTrustUrl(this.BaseUrl + url)
  }

  expandedRows: { [key: number]: boolean } = {};

  getPlainTextFromHTML(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  getFirstWords(html: string, wordLimit: number): string {
    const text = this.getPlainTextFromHTML(html);
    const words = text.split(/\s+/);
    return words.slice(0, wordLimit).join(' ') + (words.length > wordLimit ? '...' : '');
  }

  selectedRow: any
  modalContentType: any

  openDetailModal(data: any, type: any) {
    this.selectedRow = data
    this.modalContentType = type
  }


}
